export const DISABLED_FACEBOOK_LOGIN_SWITCH = 'general_disable_fb_login_20230320';
